import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  
  constructor(@Inject(PLATFORM_ID) private platformId: string) {}

  /**
   * Initialize tracking scripts only in production environment over HTTPS
   */
  initializeTracking(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    // Only load tracking scripts in production or when using HTTPS
    if (!environment.production && !this.isHttps()) {
      console.log('Tracking scripts disabled for HTTP development environment');
      return;
    }

    this.loadHotjar();
  }

  private isHttps(): boolean {
    return window.location.protocol === 'https:';
  }

  private loadHotjar(): void {
    // Only load Hotjar if we're in production or using HTTPS
    if (environment.production || this.isHttps()) {
      // Add Hotjar tracking code here if it's not already in index.html
      console.log('Hotjar tracking initialized');
    }
  }

  /**
   * Track custom events (only in production or HTTPS)
   */
  trackEvent(eventName: string, properties?: any): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (!environment.production && !this.isHttps()) {
      console.log(`Event tracking disabled: ${eventName}`, properties);
      return;
    }

    // Add your tracking logic here
    // For example: gtag('event', eventName, properties);
  }
}